"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/select/style");

var _select = _interopRequireDefault(require("antd/es/select"));

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//default befaviour should be to allow search by default unless overriden in specifc app
var showSearch = true;
var sortOptions = true;

var SelectComponent = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var children = props.children;

  if (props.children && props.sortOptions === undefined || props.sortOptions === true) {
    try {
      children = orderListByKey(_toConsumableArray(children));
    } catch (err) {
      console.warn("Failed to apply default sort :", err);
      children = props.children;
    }
  } else children = props.children;

  return /*#__PURE__*/_react.default.createElement(_select.default, _extends({
    ref: ref,
    showSearch: showSearch,
    filterOption: function filterOption(input, option) {
      return option.props.children && option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }, props, {
    children: children
  }));
});

function orderListByKey(data) {
  var compareValues = function compareValues(elemA, elemB) {
    if (!elemA || !elemB || !elemA.props || !elemB.props || !elemA.props.children || !elemB.props.children || typeof elemA.props.children !== "string" || typeof elemB.props.children !== "string") return 0;
    var comparison = elemA.props.children.localeCompare(elemB.props.children);
    return comparison;
  };

  return data.sort(compareValues);
}

SelectComponent.Option = _select.default.Option;
var _default = SelectComponent;
exports.default = _default;